import {
  UserProfileLinkGroupDocument,
  UserProfileLinkGroupMutationVariables,
} from "@graphql/api";

interface UpdateData {
  clientId?: string;
  data1?: string;
  data2?: string;
  groupId?: string;
  webId?: string;
}

export default async function userProfileLinkGroup(
  fields: UpdateData,
): Promise<boolean> {
  const client = global.window.apolloClient;

  const mutVars: UserProfileLinkGroupMutationVariables = { ...fields };
  const result = await client.mutate({
    mutation: UserProfileLinkGroupDocument,
    variables: mutVars,
  });

  if (result.data?.userProfileLinkGroup.success) {
    // Reload the Apollo cache.
    await client.resetStore();
  }

  return result.data?.userProfileLinkGroup.success ?? false;
}
